import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { importSync } from '@embroider/macros';

export default class SetupController extends Controller {
  @service audienceCredentials;
  @service analytics;
  @service router;

  _setupProviderTask = task(
    {
      drop: true,
    },
    async (type) => {
      this.analytics.track('audience', 'add_network_started', {
        type,
        startingPoint: 'Integrations',
      });

      try {
        await this.audienceCredentials.setupProviderTask.perform(type);
        this.router.transitionTo('integrations.audiences.type.settings', type);
      } catch (err) {
        // Nothing to do with the error; it's handled on the child task.
      }
    },
  );

  get setupComponent() {
    let module = importSync(`../../../../../components/audiences-setup/${this.model.type.replace('_', '-')}`);

    return module.default;
  }
}
